import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

const ConfirmBack = (props: any) => {
  return (
    <Dialog
      open={props.openConfirm}
      onClose={props.handleCloseConfirmDelete}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          入金が登録されていません。本当に「帰宅」に変更しますか？
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleCloseConfirmDelete}>キャンセル</Button>
        <Button onClick={props.handleDelete} sx={{ color: '#DA4453' }}>
          確定
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmBack;
